import { LineMessageType } from '@anyx/common-graphql';

import { useAssetUpload } from '../../shared';

export const useUnitMessageAssetUpload = () => {
  const { generateAssetUrl, uploadAsset } = useAssetUpload('LINE', 'UNIT_MESSAGE');

  const uploadUnitMessageAsset = async (
    file: File,
    messageType: LineMessageType
  ): Promise<string | undefined> => {
    return uploadAsset(async () => generateAssetUrl({ file, messageType }), file);
  };

  return {
    uploadUnitMessageAsset,
  };
};
